<div class="financing-calculator-form">
  <app-form [formGroup]="form">
    <div class="financing-calculator-form__main">
      <div class="financing-calculator-form__range-group">
        <app-grid [template]="'auto 170px'" [gap]="16" [align]="'center'">
          <app-input-title>{{ 'financingCalculator.select' | translate }}</app-input-title>
          <span class="financing-calculator-form__input">{{ calculatedData?.advancePrice ?? advance | price }} ({{ percentage[1] }}%)</span>
        </app-grid>
        @if (carPaymentOptions?.length && carPaymentOptions) {
          <app-range-slider
            [steps]="advanceSteps"
            [disabled-from]="true"
            [min-label]="carPaymentOptions[carPaymentOptions.length - 1].paymentPlans[0].advancePrice | price"
            [max-label]="carPaymentOptions[0].paymentPlans[0].advancePrice | price"
            [(value)]="percentage"
            (valueChange)="percentageChanged($event)"
            (updated)="percentageGtm()"
          ></app-range-slider>
        }
      </div>
      <div class="financing-calculator-form__range-group">
        <app-grid [template]="'auto 170px'" [gap]="16" [align]="'center'">
          <app-input-title>{{ 'financingCalculator.repaymentPeriod' | translate }}</app-input-title>
          <span class="financing-calculator-form__input">{{ months[1] | month | async }}</span>
        </app-grid>
        @if (carPaymentOptions?.length) {
          <app-range-slider [steps]="monthsSteps" [stepsLabel]="true" [disabled-from]="true" [(value)]="months" (valueChange)="repaymentPeriodChanged()" (updated)="repaymentPeriodGtm()"></app-range-slider>
        }
      </div>
      @if (calculatedData) {
        <div class="financing-calculator-form__prices">
          @if (calculatedData.monthlyPayment) {
            <div class="financing-calculator-form__prices-monthly">
              {{ 'financingCalculator.monthly' | translate }}
              <span class="financing-calculator-form__prices-monthly-main">{{ 'financingCalculator.from' | translate | lowercase }} {{ calculatedData.monthlyPayment | price }}</span>
            </div>
          }
          <div class="financing-calculator-form__prices-small">
            @if (calculatedData.interestRate) {
              <div class="financing-calculator-form__prices-item">
                {{ 'financingCalculator.interestRate' | translate }}
                <div class="financing-calculator-form__prices-item-value">{{ 'globals.from' | translate }} {{ calculatedData.interestRate | floatNumber }}%</div>
              </div>
            }
            <div class="financing-calculator-form__prices-item">
              {{ 'financingCalculator.downPayment' | translate }}
              <div class="financing-calculator-form__prices-item-value">{{ calculatedData.advancePrice | price }}</div>
            </div>
            <div class="financing-calculator-form__prices-item">
              {{ 'financingCalculator.repaymentPeriod' | translate }}
              <div class="financing-calculator-form__prices-item-value">{{ calculatedData.numberOfMonths | month | async }}</div>
            </div>
          </div>
          <span class="financing-calculator-form__example">
            {{ 'financingCalculator.example' | translate }} <app-link [href]="globals.routes()['representativeExamples'].url" [target]="'_blank'" [color]="'primary'">{{ 'financingCalculator.exampleHere' | translate }}</app-link>
          </span>
        </div>
      }
      @if (type === 'online-modal') {
        <div class="financing-calculator-form__bottom">
          <app-button class="financing-calculator-form__button" [fullsize]="true" (clicked)="onlineFormSubmit(); gtmService.pushGtmPageType({ event: 'click_cta_kalkulacka' })">
            {{ 'forms.confirm' | translate }}
          </app-button>
        </div>
      } @else if (type !== 'financing-form') {
        <div class="financing-calculator-form__bottom">
          <app-button
            class="financing-calculator-form__button"
            [fullsize]="true"
            [route]="globals.routes()['financingFormProducts'].url"
            [params]="{ car: carId }"
            [fragment]="'months=' + months[1] + '&advance=' + advance + '&loan-type=' + form.controls['loanType'].value"
            (clicked)="gtmService.pushGtmPageType({ event: 'click_cta_kalkulacka' })"
          >
            @if (type !== 'financing-modal') {
              {{ 'financingCalculator.calculate' | translate }}
            } @else {
              {{ 'forms.confirm' | translate }}
            }
          </app-button>
          @if (type !== 'financing-modal') {
            <app-link (clicked)="openCallUsModal()">{{ 'financingCalculator.callUs' | translate }}</app-link>
          }
        </div>
      }
    </div>
  </app-form>
</div>
